<template>
  <div class="adver">
    <img class="banner" :src="`${imgurl}`" alt="" />
    <div class="intro">
      <div class="left">
        <img class="line" src="../../assets/index/line.png" alt="" />
        <div class="title">
          专注高端铝包木窗私属定制 <br />
          换窗，阁韵更专业
        </div>
      </div>
    </div>
    <!-- 8大优势 -->
    <div class="eight">
      <div class="adWrap">
        <div class="big"><img src="../../assets/adver/title.png" alt="" /></div>
        <div class="ad">
          <div class="item" v-for="(item, index) in iconlist" :key="index">
            <div class="icon">
              <img :src="item.image" alt="" />
            </div>
            <div class="eiTitle">{{ item.name }}</div>
            <div class="eiDesc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 优势列表 -->
    <div>
      <div class="part">
        <div
          class="part1"
          :class="item.bg == 1 ? 'up1bg' : 'up2bg'"
          v-for="(item, index) in detaillist"
          :key="index"
        >
          <!-- 循环的列表 -->

          <div class="up2" v-if="index % 2 == 0">
            <div class="pic">
              <img :src="item.image" alt="" />
            </div>
            <div class="right">
              <div class="rightUp1">
                <div class="parTitleWrap">
                  <div class="parTitle">{{ item.name }}</div>
                  <div class="line">
                    <img src="../../assets/index/line.png" alt="" />
                  </div>
                </div>
                <div class="num">
                  <img :src="item.id_image" alt="" />
                </div>
              </div>
              <div class="desc">
                {{ item.desc }}
              </div>
            </div>
          </div>

          <div class="up1" v-else>
            <div class="pic">
              <img :src="item.image" alt="" />
            </div>
            <div class="right">
              <div class="rightUp1">
                <div class="parTitleWrap">
                  <div class="parTitle">{{ item.name }}</div>
                  <div class="line">
                    <img src="../../assets/index/line.png" alt="" />
                  </div>
                </div>
                <div class="num">
                  <img :src="item.id_image" alt="" />
                </div>
              </div>
              <div class="desc">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { advantage } from "../../api/request";

export default {
  name: "Advantage",

  data() {
    return {
      imgurl: null,
      iconlist: [],
      detaillist: [],
    };
  },
  methods: {},
  mounted() {
    advantage().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        var obj = res.data.data;
        this.imgurl = obj.banner;
        this.iconlist = obj.icon;
        this.detaillist = obj.detail;
      }
    });
  },
};
</script>

<style scoped lang="less">
.adver {
  padding-top: 60px;
  font-family: 微软雅黑, MicrosoftYaHei;
  width: 100%;
  .banner {
    position: absolute;
    top: 100px;
    left: 0;
    z-index: -1;
    width: 100%;
    height: auto;
  }
  .intro {
    width: 1280px;
    margin: 0 auto 42px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-weight: bold;
      color: #ffffff;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #004c31;
    }
  }
  .eight {
    margin-top: 500px;
    background: #ffffff;
    padding: 1px;
    .adWrap {
      background: #ffffff;
      width: 1100px;
      padding: 50px 90px 100px 90px;
      margin: -70px auto 0;
      border-radius: 20px 20px 0 0;
      box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.1);
      .big {
        width: 355px;
        height: 77px;
        margin: 23px auto 69px;
        img {
          width: 355px;
          height: 77px;
        }
      }
      .ad {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        .item {
          margin-bottom: 59px;
          width: 25%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .icon {
            width: 142px;
            height: 142px;
            img {
              width: 142px;
              height: 142px;
            }
          }
          .eiTitle {
            margin-top: 25px;
            color: #004c31;
            font-weight: bold;
          }
          .eiDesc {
            width: 180px;
            height: 60px;
            margin-top: 11px;
            font-size: 14px;
            color: #000000;
          }
        }
      }
    }
  }
  .part {
    // background: #f3f3f3;
    .up1bg {
      background: #ffffff;
    }
    .up2bg {
      background: #f3f3f3;
    }
    .part1 {
      padding: 68px 15vw 26px 15vw;
      // width: 1280px;
      // margin: 0 auto;
      overflow: hidden;

      // :nth-child(even)
      // 列表的每一项(单行图片在左 双行在右)

      // 双行
      .up2 {
        // background: #f3f3f3;
        overflow: hidden;
        // padding-bottom: 50px;

        // 图片
        .pic {
          float: left;
          width: 600px;
          height: 426px;
          img {
            width: 600px;
            height: 426px;
          }
        }
        // 文字
        .right {
          float: right;
          width: 500px;
          .rightUp1 {
            overflow: hidden;
            // display: flex;
            // align-items: center;
            // justify-content: space-between;
            .parTitleWrap {
              float: left;
              .parTitle {
                font-size: 32px;
                font-weight: bold;
                color: #004c31;
                margin-bottom: 20px;
              }
              .line {
                width: 90px;
              }
            }
            .num {
              float: right;
              width: 90px;
              height: 97px;
              img {
                width: 90px;
                height: 97px;
              }
            }
          }
          .desc {
            margin-top: 59px;
            text-align: justify;
            font-size: 20px;
            color: #6c7a77;
          }
        }
      }

      // 单行
      .up1 {
        overflow: hidden;
        // padding-bottom: 50px;

        // background: #fff;
        // 图片
        .pic {
          float: right;

          width: 600px;
          height: 426px;
          img {
            width: 600px;
            height: 426px;
          }
        }

        // 文字
        .right {
          float: left;
          width: 500px;
          .rightUp1 {
            overflow: hidden;
            // display: flex;
            // align-items: center;
            // justify-content: space-between;
            .parTitleWrap {
              float: right;
              .parTitle {
                font-size: 32px;
                font-weight: bold;
                color: #004c31;
                margin-bottom: 20px;
              }
              .line {
                width: 90px;
              }
            }
            .num {
              float: left;
              width: 90px;
              height: 97px;
              img {
                width: 90px;
                height: 97px;
              }
            }
          }
          .desc {
            margin-top: 59px;
            text-align: justify;
            font-size: 20px;
            color: #6c7a77;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .adver {
    padding-top: 60px;
    font-family: 微软雅黑, MicrosoftYaHei;
    width: 100%;
    .banner {
      position: absolute;
      top: 100 * 3px;
      left: 0;
      z-index: -1;
      width: 100%;
      height: auto;
    }
    .intro {
      width: 1280px;
      margin: 0 auto 42px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-weight: bold;
        color: #ffffff;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
      }
    }
    .eight {
      margin-top: 400px;
      background: #ffffff;
      padding: 1px;
      .adWrap {
        background: #ffffff;
        width: 1400px;
        padding: 50px 90px 100px 90px;
        margin: -70px auto 0;
        border-radius: 20px 20px 0 0;
        box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.1);
        .big {
          width: 355 * 2px;
          height: 77 * 2px;
          margin: 23px auto 69px;
          img {
            width: 355 * 2px;
            height: 77 * 2px;
          }
        }
        .ad {
          display: flex;
          align-items: baseline;
          justify-content: space-around;
          flex-wrap: wrap;
          .item {
            margin-bottom: 59px;
            width: 25%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .icon {
              width: 142 * 2px;
              height: 142 * 2px;
              img {
                width: 142 * 2px;
                height: 142 * 2px;
              }
            }
            .eiTitle {
              font-size: 24px;
              margin-top: 25px;
              color: #004c31;
              font-weight: bold;
            }
            .eiDesc {
              width: 300px;
              height: auto;
              min-height: 300px;
              text-align: left;
              margin-top: 11 * 2px;
              font-size: 14 * 2px;
              color: #000000;
            }
          }
        }
      }
    }
    .part {
      // background: #f3f3f3;
      .up1bg {
        background: #ffffff;
      }
      .up2bg {
        background: #f3f3f3;
      }
      .part1 {
        // padding: 0;
        padding: 68px 140px 26px 120px;
        // width: 1280px;
        // margin: 0 auto;
        // overflow: hidden;

        // :nth-child(even)
        // 列表的每一项(单行图片在左 双行在右)

        // 双行
        .up2 {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          // background: #f3f3f3;
          // overflow: hidden;
          // padding-bottom: 50px;

          // 图片
          .pic {
            // float: left;
            width: 600px;
            height: 426px;
            img {
              width: 600px;
              height: 426px;
            }
          }
          // 文字
          .right {
            // float: right;
            width: 500 * 2px;
            .rightUp1 {
              // overflow: hidden;
              display: flex;
              // align-items: center;
              justify-content: space-between;
              .parTitleWrap {
                overflow: hidden;
                // border: 1px solid blue;
                // float: left;
                .parTitle {
                  font-size: 32px;
                  font-weight: bold;
                  color: #004c31;
                  margin-bottom: 20px;
                }
                .line {
                  width: 90px;
                }
              }
              .num {
                // float: right;
                width: 90 * 2px;
                height: 97 * 2px;
                img {
                  width: 90 * 2px;
                  height: 97 * 2px;
                }
              }
            }
            .desc {
              margin-top: 59 * 2px;
              // text-align: justify;
              font-size: 20 * 2px;
              color: #6c7a77;
            }
          }
        }

        // 单行
        .up1 {
          // display: flex;
          // justify-content: space-between;

          // overflow: hidden;
          // padding-bottom: 50px;

          // background: #fff;
          // 图片
          .pic {
            float: right;

            width: 600px;
            height: 426px;
            img {
              width: 600px;
              height: 426px;
            }
          }

          // 文字
          .right {
            float: left;

            width: 500 * 2px;
            .rightUp1 {
              // overflow: hidden;
              // display: flex;
              // align-items: center;
              // justify-content: space-between;
              .parTitleWrap {
                float: right;
                .parTitle {
                  font-size: 32px;
                  font-weight: bold;
                  color: #004c31;
                  margin-bottom: 20px;
                }
                .line {
                  width: 90px;
                }
              }
              .num {
                float: left;
                width: 90 * 2px;
                height: 97 * 2px;
                img {
                  width: 90 * 2px;
                  height: 97 * 2px;
                }
              }
            }
            .desc {
              margin-top: 59 * 2px;
              // text-align: justify;
              font-size: 20 * 2px;
              color: #6c7a77;
            }
          }
        }
      }
    }
  }
}
</style>
